import { ErrorHandler, Injectable, Injector } from '@angular/core';

import { LogService } from './logging';
import { FirebaseService } from './shared/services/firebase.service';
import { LocalStorageUtil } from './shared/utils/local-storage.util';

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {
	constructor(private injector: Injector) {}

	handleError(error: Error) {
		if (!error.message?.includes('auth/')) {
			const logService = this.injector.get(LogService);
			const auth = this.injector.get(FirebaseService).auth;
			logService.error(
				error.message,
				{
					path: window.location.toString(),
					email: auth.currentUser?.email,
					userId: LocalStorageUtil.getUserId(),
					clientId: LocalStorageUtil.getActiveClientId(),
				},
				error,
			);
		}
	}
}
